<template>
  <section class="qv-card">
    <p class="qv-section-title">Pré-pedido</p>

    <template v-if="loading">
      <div class="qv-field-row" v-if="!readOnly">
        <span class="qv-sk qv-sk-label" style="width: 64px;"></span>
        <span class="qv-sk qv-sk-input"></span>
      </div>
      <div class="qv-field-row">
        <div class="qv-field-info">
          <span class="qv-sk qv-sk-label" style="width: 56px;"></span>
          <span class="qv-sk qv-sk-value" style="width: 80px; height: 13px;"></span>
        </div>
        <span class="qv-sk qv-sk-btn"></span>
      </div>
    </template>

    <template v-else>
      <div class="qv-field-row" v-if="!readOnly">
        <span class="qs-label">Quantidade</span>

        <a-input
          v-model="localQuantity"
          size="small"
          class="qv-qty-input"
          :disabled="quantityLocked"
          @input="handleInput"
          @blur="handleBlur"
          @pressEnter="handleBlur"
        />
      </div>

      <div class="qv-field-row">
        <div class="qv-field-info">
          <span class="qs-label">Embalagem</span>
          <span class="qs-value">{{ packaging || '—' }}</span>
        </div>

        <a-button
          size="small"
          icon="edit"
          :disabled="!canEditPackaging"
          @click="$emit('edit-packaging')"
        >
          Editar
        </a-button>
      </div>

      <p v-if="!canEditPackaging" class="qv-hint">
        Edição de embalagem indisponível para produtos genéricos ou derivados.
      </p>
    </template>
  </section>
</template>

<script>
export default {
    name: 'QvPreorderActions',

    props: {
        quantity: {
            type: [String, Number],
            default: 0,
        },

        canEditPackaging: {
            type: Boolean,
            default: false,
        },

        readOnly: {
            type: Boolean,
            default: false,
        },

        quantityLocked: {
            type: Boolean,
            default: false,
        },

        packaging: {
            type: String,
            default: '',
        },

        loading: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            localQuantity: this.quantity || 0,
        };
    },

    watch: {
        quantity(value) {
            this.localQuantity = value || 0;
        },
    },

    methods: {
        handleInput(event) {
            this.localQuantity = event.target.value.replace(/\D/g, '');
        },

        handleBlur() {
            if (this.quantityLocked) return;

            const value = String(this.localQuantity || '0').replace(/\D/g, '') || '0';

            this.localQuantity = value;

            if (value === String(this.quantity || '0')) {
                return;
            }

            this.$emit('update-quantity', value);
        },
    },
};
</script>

<style lang="scss" scoped>
@import './_qv-shared.scss';

.qv-field-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  padding: 9px 12px;
}

.qv-field-row + .qv-field-row {
  margin-top: 8px;
}

.qv-field-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.qv-qty-input {
  width: 110px;
  flex-shrink: 0;
  text-align: right;
  font-weight: 700;
}

.qv-hint {
  margin: 8px 0 0;
  font-size: 10.5px;
  color: var(--text-3);
}

.qv-sk-input {
  width: 90px;
  height: 24px;
  border-radius: 4px;
}

.qv-sk-btn {
  width: 64px;
  height: 24px;
  border-radius: 4px;
}
</style>
